import * as React from 'react';
import type { FieldMetaState, FieldRenderProps } from 'react-final-form';

import type { TextFieldProps } from '@coursera/cds-core';
import { TextField } from '@coursera/cds-core';

import type { CmlContent } from 'bundles/cml';
import RichTextField from 'bundles/portfolio-projects/components/RichTextField';

const getValidationLabel = ({ submitError, error: errorTree }: FieldMetaState<unknown>) =>
  (submitError || errorTree) ?? '';

const getValidationStatus = (meta: FieldMetaState<unknown>) => (meta.touched && meta.error ? 'error' : undefined);

export const FormTextField = ({ input, meta, label, ...rest }: FieldRenderProps<string>) => {
  return (
    <TextField
      {...input}
      {...rest}
      type={(input.type as TextFieldProps['type']) || 'text'}
      onChange={(e) => input.onChange(e.target.value)}
      label={label}
      validationLabel={getValidationLabel(meta)}
      validationStatus={getValidationStatus(meta)}
    />
  );
};

export const FormRichTextField = ({ input, label, meta, ...rest }: FieldRenderProps<CmlContent>) => {
  return (
    <RichTextField
      {...input}
      {...rest}
      label={label}
      initialCML={input.value}
      onContentChange={(e) => input.onChange(e)}
      validationLabel={getValidationLabel(meta)}
      validationStatus={getValidationStatus(meta)}
    />
  );
};
